import ReopenConversation from 'models/modal/reopen_conversation';

export default class ShowReopenConversationModal {
  constructor(context) {
    this.context = context;
  }

  run({ routingGroupId } = {}) {
    this.context.stores.modal.set(ReopenConversation.create({ routingGroupId }));
  }
}
